import React from 'react'

// For function component
export const useViewData = () => React.useMemo(getViewData, [])

// For class component
export const getViewData = () => {
  try {
    return JSON.parse(document.querySelector('meta[name=x-application-data]').content) || {}
  } catch (e) {
    return {}
  }
}
